import "core-js/modules/es.array.push.js";
import "core-js/modules/es.string.link.js";
var Group = {
  name: 'AStepItemGroup',
  props: {
    align: {
      type: String,
      default: 'center',
      validator: function validator(value) {
        return ['left', 'center', 'right'].indexOf(value) != -1;
      }
    }
  },
  render: function render(h) {
    return h('div', {
      attrs: {
        style: "text-align: ".concat(this.align, "; margin-top: 8px")
      }
    }, [h('div', {
      attrs: {
        style: 'text-align: left; display: inline-block;'
      }
    }, [this.$slots.default])]);
  }
};
export default {
  name: 'AStepItem',
  Group: Group,
  props: ['title', 'icon', 'link', 'titleStyle', 'iconStyle'],
  methods: {
    go: function go() {
      var link = this.link;
      if (link) {
        this.$router.push(link);
      }
    }
  }
};